import apiUrl from '../../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate';
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import download from 'downloadjs';
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
export default {
  name: 'UnicomInventoryCOmparisonreport',
  components: {
    //Paginate,
    Pagination,
    DatePicker,
    download,
    JsonExcel,
    Loader
  },
  props: [],
  data() {
    return {
      isLoadingforxls: false,
      show: false,
      download: true,
      dataFilter2: '',
      reportname: '',
      csvFieldsForXls1: {},
      listReportDataforxls1: [],
      csvFieldsForXls2: {},
      listReportDataforxls2: [],
      listcancelunicomInventoryReportData: [],
      listcancelunicomInventoryReportDataCsv: [],
      csvFields: [],
      currentPage: 1,
      totalPage: 0,
      //totalCount:0,
      pageLimit: 10,

      // perPage: 10,
      // pageno: 0,
      totalRows: 0,
      // totalPage: 0,
      isLoading: false,
      formattedDate: '',
      resultCount: '',
      listClientData: [],
      listWarehouseData: [],
      ClientErr: '',
      WarehouseErr: '',
      searchFlag: false,
      showSelectWarehouse: false,
      showSelectClient: false,
      clientid: '',
      warehouseid: '',
      warehouse: '',
      client: '',
      ClientProductID: '',
      ProductID: '',
      user_type: '',
      warehousetype: '',
      limitExeed: false,
      recordLimit: 0,
      Status: 'inventry',
      getpass: '',
      getpassErr: '',
      FCClientProductID:'',
      FCProductID:'',
      FCRackID:'',
      matchedinventorydropdown:'',
      listreportfcinventorydata:[],
      listreportfcinventorydataCsv:[],
      labeltypeErr:'',
      totalPageFC:0,
      totalRowsFC:0,
      currentPageFC:1
    }
  },
  computed: {

  },
  filters: {
    moment: function (date) {
      if (!date) return '';
      return moment(date).format('DD-MM-YY HH:mm:ss');
    }
  },
  mounted() {
    var permissionEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.udetail = userdetail
    this.createdbyEmail = userdetail.email;
    var today = new Date();
    this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
    this.reportname =  this.$t('editedjson.unicomInventoryComparisonreport')
    this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
    this.user_type = userdetail.utype;
    this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
    this.getWarehouseList()
    switch (this.user_type) {
      case 'system_user':
        this.showSelectClient = true;
        this.showSelectWarehouse = true;
        // this.getClientList();
        // this.getWarehouseList();
        break;

      case 'client_user':
        this.clientid = userdetail.clientid;
        this.client = this.clientid;
        // this.getWarehouseList();
        this.showSelectWarehouse = true;
        break;

      case 'warehouse_user':
        this.warehouseid = userdetail.warehouseid;
        this.warehouse = this.warehouseid;
        this.showSelectClient = true;
        // this.getClientList();
        break;

      default:
        this.$alertify.error("Unauthorised user, Please contact your system admin");
        break
    }
    this.getRecordLimit()
  },
  methods: {
    async getpassApi() {
      //to hit multiseller API
      //pullGatepassData
      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');


      if (window.localStorage.getItem('selectedClient')==='undefined') {
        this.$alertify.error(this.$t('common.clientError'))
        this.pageno = this.totalPage = 0;
        this.listcancelunicomInventoryReportData = [];
        return false;
      }
      if (this.user_type == 'warehouse_user') {
        this.warehouse = this.warehouseid
        // await this.getWarehouseList()
      }
      this.warehouseid = this.warehouse
      if (window.localStorage.getItem('selectedClient')==='undefined') {
        this.$alertify.error(this.$t('common.clientError'))
        this.pageno = this.totalPage = 0;
        this.listcancelunicomInventoryReportData = [];
        return false;
      }

      if (this.getpass == '') {
        this.getpassErr = this.$t('unicommerce.unicomminventory.getPassNoPlaceholder');

        this.pageno = this.totalPage = 0;
        this.listcancelunicomInventoryReportData = [];
        return false;
      }
      let obj = this.listWarehouseData.find(o => o.warehouseid ==window.localStorage.getItem('selectedWarehouse'));

      this.input = ({

        warehouseid: window.localStorage.getItem('selectedWarehouse'),
        clientid: window.localStorage.getItem('selectedClient'),
        createdby: this.createdbyEmail,
        warehousename: obj['warehousename']

      });
      this.input.gatePassCodes = []
      this.input.gatePassCodes.push(this.getpass),


        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'pullGatepassData',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr,
          }
        })
          .then(result => {

            if (result.data.Pushdata.status == false) {
              this.$alertify.error(result.data.Pushdata.msg)
            }
            else {
              this.$alertify.success(result.data.Pushdata.msg)
            }

          }, error => {
            console.error(error);
          });

    },
    loadReport(status) {
      this.Status = status;
      this.resetSearchForm();
    },
    getRecordLimit() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({

      })
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getRecordLimit',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then(result => {
          if (result.data) {
            this.recordLimit = result.data.data;


          }
        }, error => {
          console.error(error)
        })
    },
    startDownload() {
      this.isLoadingforxls = true;
    },
    finishDownload() {
      this.isLoadingforxls = false;
    },
    Choosetype() {
      this.show = true;
      this.download = false;
      if (this.warehousetype == "Flipkart Smart") {
        this.getCancelPutawayReportDataSmartForXls(3)
      }
      if (this.warehousetype != "Flipkart Smart") {
        this.getCancelPutawayReportDataForXls(3)

      }


    },

    export(data, filename, mime) {
      let blob = this.base64ToBlob(data, mime);
      download(blob, filename, mime);
    },

    base64ToBlob(data, mime) {
      let base64 = window.btoa(window.unescape(encodeURIComponent(data)));
      let bstr = atob(base64);
      let n = bstr.length;
      let u8arr = new Uint8ClampedArray(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: mime
      })
    },

    // getClientList() {
    //   this.pageno = 0;
    //   if (window.localStorage.getItem("clientList") !== null) {
    //     var clientListEncrypt = window.localStorage.getItem('clientList');
    //     var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
    //     var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
    //     this.listClientData = JSON.parse(plaintextclient);
    //   } else {

    //     var userToken = window.localStorage.getItem('userToken');
    //     var myStr = userToken.replace(/"/g, '');
    //     this.input = ({
    //       warehouseid: this.warehouseid,
    //     });

    //     axios({
    //       method: 'POST',
    //       'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
    //       'data': this.input,
    //       headers: {
    //         'Authorization': 'Bearer ' + myStr,
    //       }
    //     })
    //       .then(result => {
    //         this.listClientData = result.data.data;
    //       }, error => {
    //         console.error(error);
    //       });
    //   }
    // },

    getWarehouseList() {
      return new Promise(async (resolve, reject) => {
        this.pageno = 0;

        if (window.localStorage.getItem("warehouseList") !== null) {
          var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
          var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
          var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
          this.listWarehouseData = JSON.parse(plaintextwarehouse);
        } else {

          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');
          this.input = ({
            clientid: this.clientid,
          });

          await axios({
            method: 'POST',
            'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
            'data': this.input,
            headers: {
              'Authorization': 'Bearer ' + myStr
            }
          })
            .then(result => {
              this.listWarehouseData = result.data.data;
              resolve(true)
            }, error => {
              console.error(error)
              resolve(false)
            })
        }
      })
    },

    // clientSelected() {
    //   if (this.clientid != this.client) {
    //     this.clientid = this.client;
    //     if (this.user_type != 'warehouse_user') {
    //       this.listWarehouseData = []
    //       this.getWarehouseList();
    //       if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
    //         this.warehouse = this.warehouseid = '';
    //       } else {
    //         this.warehouse = ''
    //       }
    //     } else {
    //       if (this.warehouseid && this.clientid);
    //       // this.getCancelPutawayReportData();
    //     }
    //   }
    //   this.listcancelunicomInventoryReportData = [];
    //   this.pageno = this.totalPage = 0;
    // },

    // warehouseSelected() {
    //   this.warehouseid = this.warehouse;
    //   this.pageno = this.totalPage = 0;
    //   if (this.warehouseid) {
    //     if (this.clientid) {
    //       // this.getCancelPutawayReportData();
    //     } else {
    //       this.getClientList();
    //     }
    //   }
    // },
    getCancelPutawayReportDataSearch() {
      this.currentPage = 1;
      this.totalPage = 0;
      this.searchFlag = true;
      if (this.warehousetype == "Flipkart Smart") {
        this.getCancelPutawayReportDataSmart();
      }
      else {
        this.getCancelPutawayReportData();
      }

    },
    //to get client list
    async getCancelPutawayReportDataFC(csvCheck=0){
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.isLoadingforxls = false
      var dataFilter = {};
      if (csvCheck == 2) {
        this.show = false;
        this.download = true;
        this.limitExeed = false;
      }
      if (window.localStorage.getItem('selectedClient')==='undefined') {
        this.$alertify.error(this.$t('common.clientError'))
        this.pageno = this.totalPageFC = 0;
        this.listreportfcinventorydata = [];
        return false;
      }
      if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
        this.$alertify.error(this.$t('common.warehouseError'))
        this.pageno = this.totalPageFC = 0;
        this.listreportfcinventorydata = [];
        return false;
      }
      if(this.matchedinventorydropdown.trim()===""){
        this.labeltypeErr=this.$t('Label Matched Inventory is required')
        this.pageno = this.totalPageFC = 0;
        this.listreportfcinventorydata = [];
        return false;
      }
      this.isLoading = true;
      this.input = ({
        clientid: 1050,
        warehouseid: 2,
        matched:this.matchedinventorydropdown,
        clientproductid: this.FCClientProductID,
        productid: this.FCProductID,
        rackid:this.FCRackID,
        offset: (this.currentPageFC - 1) * 200,
        limit: 200,
        csvData: csvCheck,
      })
      Object.entries(this.input).forEach(([k, v]) => {
        let skipkeys = ['offset', 'limit', 'csvData'];
        if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
          dataFilter[k] = v;
        }
      })
      await  axios({
        method: 'POST',
        'url': apiUrl.api_url + 'inventaryCheckFVAndWMS',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
      .then(result => {
        // console.log(result.data)
        if (result.data.ErrorCode == 0) {
          if (csvCheck == 1) {
            this.show = true;
            this.download = false;
            this.listreportfcinventorydataCsv = [];
            this.csvFields = {
              'clientproductid': this.$t('srmaster.table.clientProductID'),
              'fcproductid':this.$t('fcproductid'),
              'eancode': this.$t('pickingReport.table.columns.eanCode'),
              'productid': this.$t('packingReportList.table.columns.productId'),
              'productname': this.$t('common.productName'),
              'totalqty': this.$t('editedjson.wmstotalQty'),
              'rackqty': this.$t('editedjson.wmsrackQty'),
              'rackid': this.$t('editedjson.wmsRackId'),
              'fcrackid':this.$t('fcrackid'),
              'inventory': this.$t('editedjson.uniCommerceInventory'),
              'inventoryBlocked':  this.$t('editedjson.UniCommerceBlockedInventory'),
              'isfc': this.$t('isfc'),
              'mrp': this.$t('common.mrp'),

            };
            var dateFilter = [];
            var skipFilter = [];
            this.listreportfcinventorydataCsv = result.data.data;
            csvHelper.data.jsonToCSV(this.$t('FC Inventory Comparison'), this.listreportfcinventorydataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

            this.isLoading = false;
          } else {
            this.listreportfcinventorydata = result.data.data;
            if (result.data.errorCode == -1) {
              this.resultCount = 0;
            } else {
              this.totalRowsFC = result.data.count
              if (Number(this.totalRowsFC) > Number(this.recordLimit)) {
                this.limitExeed = true
              }
              this.resultCount = result.data.count
              if (this.totalRowsFC < 200) {
                this.totalPageFC = 1
              } else {
                this.totalPageFC = Math.ceil(this.totalRowsFC / 200);
              }
            }
          }

          this.isLoading = false;
        }
        else {
          this.totalRowsFC = 0;
          this.resultCount = 0;
          this.listreportfcinventorydata = [];
          this.$alertify.error(result.data.msg);
          this.isLoading = false;
        }

      }, error => {
        console.error(error);
      })
    },
    getCancelPutawayReportData(csvCheck = 0) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var fr_date = '';
      var to_date = '';
      var dataFilter = {};
      this.isLoadingforxls = false
      if (csvCheck == 2) {
        this.show = false;
        this.download = true;
        this.limitExeed = false;
      }
      if (window.localStorage.getItem('selectedClient')==='undefined') {
        this.$alertify.error(this.$t('common.clientError'))
        this.pageno = this.totalPage = 0;
        this.listcancelunicomInventoryReportData = [];
        return false;
      }
      if (this.user_type == 'warehouse_user') {
        this.warehouse = this.warehouseid
      }
      if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
        this.$alertify.error(this.$t('common.warehouseError'))
        this.pageno = this.totalPage = 0;
        this.listcancelunicomInventoryReportData = [];
        return false;
      }

      // if (this.warehousetype == "Flipkart Smart" && this.ClientProductID == "" && this.ProductID == "") {
      //   this.$alertify.error("Please Enter Product To Search For Smart");
      //   return false;
      // }


      this.isLoading = true;
      this.input = ({
        clientid: window.localStorage.getItem('selectedClient'),
        warehouseid: window.localStorage.getItem('selectedWarehouse'),
        clientproductid: this.ClientProductID.trim(),
        productid: this.ProductID,
        //warehousetype: this.warehousetype,
        offset: (this.currentPage - 1) * 10,
        limit: this.pageLimit,
        csvData: csvCheck,
      })
      Object.entries(this.input).forEach(([k, v]) => {
        let skipkeys = ['offset', 'limit', 'csvData'];
        if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
          dataFilter[k] = v;
        }
      })
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'inventaryCheckUnicommerceAndWMS',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then(result => {
          if (result.data.data.ErrorCode == 0) {
            if (csvCheck == 1) {
              this.show = true;
              this.download = false;
              this.listcancelunicomInventoryReportDataCsv = [];
              this.csvFields = {
                'clientproductid': this.$t('srmaster.table.clientProductID'),
                'eancode': this.$t('pickingReport.table.columns.eanCode'),
                'productid': this.$t('packingReportList.table.columns.productId'),
                'inventory': this.$t('editedjson.uniCommerceInventory'),
                'inventoryBlocked':  this.$t('editedjson.UniCommerceBlockedInventory'),
                'productname': this.$t('common.productName'),
                'isUnicomm': this.$t('editedjson.isinUnicommerce'),
                'mrp': this.$t('common.mrp'),
                'rackid': this.$t('editedjson.wmsRackId'),
                'rackqty': this.$t('editedjson.wmsrackQty'),
                'totalqty': this.$t('editedjson.wmstotalQty'),
                'unicomrackid': this.$t('unicommerce.unicomminventory.uniwarerackid'),

              };
              var dateFilter = [];
              var skipFilter = [];
              this.listcancelunicomInventoryReportDataCsv = result.data.data.data.data;
              csvHelper.data.jsonToCSV(this.$t('editedjson.unicomInventoryComparisonreport'), this.listcancelunicomInventoryReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

              // this.jsonToCSV('UnicomInventoryComparisonreportReport', this.listcancelunicomInventoryReportDataCsv, this.csvFields, dateFilter, skipFilter);
              this.isLoading = false;
            } else {
              this.listcancelunicomInventoryReportData = result.data.data.data.data;
              if (result.data.errorCode == -1) {
                this.resultCount = 0;
              } else {
                // this.totalRows = result.data.count;
                // this.resultCount = result.data.count;
                // if (this.totalRows <= this.perPage) {
                //   this.totalPage = 1;
                // } else {
                //   this.totalPage = Math.ceil(this.totalRows / this.perPage);
                // }
                this.totalRows = result.data.data.data.totalCount
                if (Number(this.totalRows) > Number(this.recordLimit)) {
                  this.limitExeed = true
                }
                this.resultCount = result.data.data.data.totalCount;
                if (this.totalRows < 10) {
                  this.totalPage = 1
                } else {
                  this.totalPage = Math.ceil(this.totalRows / 10);
                }
              }
            }

            this.isLoading = false;
          }
          else {
            this.totalRows = 0;
            this.resultCount = 0;
            this.listcancelunicomInventoryReportData = [];
            this.$alertify.error(result.data.data.msg);
            this.isLoading = false;
          }

        }, error => {
          console.error(error);
        })
    },

    getCancelPutawayReportDataSmart(csvCheck = 0) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var fr_date = '';
      var to_date = '';
      var dataFilter = {};
      if (csvCheck == 2) {
        this.show = false;
        this.download = true;
        this.limitExeed = false;
      }
      if (window.localStorage.getItem('selectedClient')==='undefined') {
        this.$alertify.error(this.$t('common.clientError'))
        this.pageno = this.totalPage = 0;
        this.listcancelunicomInventoryReportData = [];
        return false;
      }
      if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
        this.$alertify.error(this.$t('common.warehouseError'))
        this.pageno = this.totalPage = 0;
        this.listcancelunicomInventoryReportData = [];
        return false;
      }

      if (this.warehousetype == "Flipkart Smart" && this.ClientProductID == "" && this.ProductID == "") {
        this.$alertify.error("Please Enter Product To Search For Smart");
        return false;
      }


      this.isLoading = true;
      this.input = ({
        clientid: window.localStorage.getItem('selectedClient'),
        warehouseid: window.localStorage.getItem('selectedWarehouse'),
        clientproductid: this.ClientProductID.trim(),
        productid: this.ProductID,
        //warehousetype: this.warehousetype,
        offset: (this.currentPage - 1) * 10,
        limit: this.pageLimit,
        csvData: csvCheck,
      })
      Object.entries(this.input).forEach(([k, v]) => {
        let skipkeys = ['offset', 'limit', 'csvData'];
        if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
          dataFilter[k] = v;
        }
      })
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'inventaryCheckUnicommerceAndWMSSmart',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then(result => {
          if (csvCheck == 1) {
            this.listcancelunicomInventoryReportDataCsv = [];
            this.csvFields = {
              'clientproductid': this.$t('srmaster.table.clientProductID'),
              'eancode':  this.$t('pickingReport.table.columns.eanCode'),
              'productid':  this.$t('packingReportList.table.columns.productId'),
              'inventory':  this.$t('editedjson.uniCommerceInventory'),
              'inventoryBlocked':  this.$t('editedjson.UniCommerceBlockedInventory'),
              'productname': this.$t('common.productName'),
              'isUnicomm': this.$t('editedjson.isinUnicommerce'),
              'mrp': this.$t('common.mrp'),
              'rackid': this.$t('editedjson.wmsRackId'),
              'rackqty': this.$t('editedjson.wmsrackQty'),
              'totalqty': this.$t('editedjson.wmstotalQty'),
              'unicomrackid': this.$t('unicommerce.unicomminventory.uniwarerackid'),

            };
            var dateFilter = [];
            var skipFilter = [];
            this.listcancelunicomInventoryReportDataCsv = result.data.data.data.data;
            csvHelper.data.jsonToCSV(this.$t('editedjson.unicomInventoryComparisonreport'), this.listcancelunicomInventoryReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

            // this.jsonToCSV('CancelPutawayReport', this.listcancelunicomInventoryReportDataCsv, this.csvFields, dateFilter, skipFilter);
            this.isLoading = false;
          } else {
            this.listcancelunicomInventoryReportData = result.data.data.data.data;
            if (result.data.errorCode == -1) {
              this.resultCount = 0;
            } else {
              // this.totalRows = result.data.count;
              // this.resultCount = result.data.count;
              // if (this.totalRows <= this.perPage) {
              //   this.totalPage = 1;
              // } else {
              //   this.totalPage = Math.ceil(this.totalRows / this.perPage);
              // }
              this.totalRows = result.data.data.data.totalCount;
              if (Number(this.totalRows) > Number(this.recordLimit)) {
                this.limitExeed = true
              }
              this.resultCount = result.data.data.data.totalCount;
              if (this.totalRows < 10) {
                this.totalPage = 1
              } else {
                this.totalPage = Math.ceil(this.totalRows / 10);
              }
            }
          }
          this.isLoading = false;
        }, error => {
          console.error(error);
        })
    },

    //to get pagination
    // getPaginationData(pageNum) {
    //   this.pageno = (pageNum - 1) * this.perPage;
    //   this.getCancelPutawayReportData();
    // },
    getCancelPutawayReportDataForXls(csvCheck = 0) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var fr_date = '';
      var to_date = '';
      this.show = true;
      this.download = false;
      this.dataFilter2 = [];
      var value = '';
      var str = '';
      if (window.localStorage.getItem('selectedClient')==='undefined') {
        this.ClientErr = 'Client is required';
        this.pageno = this.totalPage = 0;
        this.listcancelunicomInventoryReportData = [];
        return false;
      }
      if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
        this.$alertify.error(this.$t('common.warehouseError'))
        this.pageno = this.totalPage = 0;
        this.listcancelunicomInventoryReportData = [];
        return false;
      }

      if (this.warehousetype == "Flipkart Smart" && this.ClientProductID == "" && this.ProductID == "") {
        this.$alertify.error("Please Enter Product To Search For Smart");
        return false;
      }


      this.input = ({
        clientid: window.localStorage.getItem('selectedClient'),
        warehouseid: window.localStorage.getItem('selectedWarehouse'),
        clientproductid: this.ClientProductID.trim(),
        productid: this.ProductID,
        offset: (this.currentPage - 1) * 10,
        limit: this.pageLimit,
        csvData: csvCheck,
      })
      Object.entries(this.input).forEach(([k, v]) => {
        let skipkeys = ['offset', 'limit', 'csvData'];
        if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
          value += k + ':' + v + ','
          this.dataFilter2 = str.concat(value);

        }
      })
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'inventaryCheckUnicommerceAndWMS',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then(result => {
          if (csvCheck == 3) {
            if (result.data.data.data.data.length > 0) {
              this.listReportDataforxls1 = [];
              this.csvFieldsForXls1 =[];
              this.csvFieldsForXls1[this.$t('srmaster.table.clientProductID')] =  'productid',
              this.csvFieldsForXls1[this.$t('inwardList.printData.productDetails.eanCode')] = 'eancode',
              this.csvFieldsForXls1[this.$t('editedjson.uniCommerceInventory')] = 'inventory',
              this.csvFieldsForXls1[this.$t('editedjson.UniCommerceBlockedInventory')] = 'inventoryBlocked',
              this.csvFieldsForXls1[this.$t('productPlaceHolder.productCategory')] =  'productname',
              this.csvFieldsForXls1[ this.$t('editedjson.isinUnicommerce')] =  'isUnicomm',
              this.csvFieldsForXls1[this.$t('common.mrp')] = 'mrp',
              this.csvFieldsForXls1[this.$t('editedjson.wmsRackId')] = 'rackid',
              this.csvFieldsForXls1[this.$t('editedjson.wmsrackQty')] = 'rackqty',
              this.csvFieldsForXls1[this.$t('editedjson.wmstotalQty')] = 'totalqty',
              this.csvFieldsForXls1[this.$t('unicommerce.unicomminventory.uniwarerackid')] = 'unicomrackid',


              this.listReportDataforxls1 = result.data.data.data.data;
            }
            else {
              if (result.data.data.status == true) {
                this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
              } else {
                this.$alertify.error(result.data.data.data.msg);
              }
            }


          }
          // if(result.data.data.ErrorCode == 0)
          // {
          //   if (csvCheck == 1) {
          //     this.listReportDataforxls = [];
          //
          //
          //     // this.jsonToCSV('UnicomInventoryComparisonreportReport', this.listcancelunicomInventoryReportDataCsv, this.csvFields, dateFilter, skipFilter);
          //     this.isLoading = false;
          //   }
          //   this.isLoading = false;
          // }
          // else {
          //    this.$alertify.error(result.data.data.msg);
          //    this.isLoading = false;
          // }

        }, error => {
          console.error(error);
        })
    },

    getCancelPutawayReportDataSmartForXls(csvCheck = 0) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var fr_date = '';
      var to_date = '';
      this.show = true;
      this.download = false;
      this.dataFilter2 = [];
      var value = '';
      var str = '';
      if (window.localStorage.getItem('selectedClient')==='undefined') {
        this.$alertify.error(this.$t('common.clientError'))
        this.pageno = this.totalPage = 0;
        this.listcancelunicomInventoryReportData = [];
        return false;
      }
      if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
        this.$alertify.error(this.$t('common.warehouseError'))
        this.pageno = this.totalPage = 0;
        this.listcancelunicomInventoryReportData = [];
        return false;
      }

      if (this.warehousetype == "Flipkart Smart" && this.ClientProductID == "" && this.ProductID == "") {
        this.$alertify.error("Please Enter Product To Search For Smart");
        return false;
      }


      this.isLoading = true;
      this.input = ({
        clientid: window.localStorage.getItem('selectedClient'),
        warehouseid: window.localStorage.getItem('selectedWarehouse'),
        clientproductid: this.ClientProductID.trim(),
        productid: this.ProductID,
        warehousetype: this.warehousetype,
        offset: (this.currentPage - 1) * 10,
        limit: this.pageLimit,
        csvData: csvCheck,
      })
      Object.entries(this.input).forEach(([k, v]) => {
        let skipkeys = ['offset', 'limit', 'csvData'];
        if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
          value += k + ':' + v + ','
          this.dataFilter2 = str.concat(value);

        }
      })
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'inventaryCheckUnicommerceAndWMSSmart',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then(result => {
          if (csvCheck == 3) {
            this.isLoading = false;
            if (result.data.data.length > 0) {
              this.listReportDataforxls2 = [];
              this.csvFieldsForXls2 = {
                'Client Product ID': 'clientproductid',
                'EAN Code': 'eancode',
                'Product ID': 'productid',
                'UniCommerce Inventory': 'inventory',
                'UniCommerce Blocked Inventory': 'inventoryBlocked',
                'Product Name': 'productname',
                'Is In Unicommerce': 'isUnicomm',
                'MRP': 'mrp',
                'WMS Rack Id': 'rackid',
                'WMS Rack Qty': 'rackqty',
                'WMS Total Qty': 'totalqty',
                'Uniware Rack Id': 'unicomrackid',

              };

              this.listReportDataforxls2 = result.data.data.data.data;
            }
            else {
              if (result.data.status == true) {
                this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
              } else {
                this.$alertify.error(result.data.msg.message);
              }
            }


          }

          this.isLoading = false;
        }, error => {
          console.error(error);
        })
    },
    onPageChange(page) {
      this.currentPage = page;
      this.getCancelPutawayReportData()
    },
    onPageChangeFC(page){
      this.currentPageFC=page;
      this.getCancelPutawayReportDataFC()
    },
    dateFormat(date, toFrom) {
      if (!toFrom)
        toFrom = '00:00:00'
      else
        toFrom = '23:59:59'
      if (!date)
        return '';
      return moment(date).format('YYYY-MM-DD ' + toFrom);
    },

    dateFormatFRT(date) {
      if (!date) return '';
      return moment(date).format('DD-MM-YY HH:mm:ss');
    },

    //to reset search form
    resetSearchForm() {
      this.getpass = ''
      this.warehouse = '';
      this.show = false;
      this.download = true;
      this.ProductID = '';
      this.ClientProductID = '';
      this.pageno = 0;
      this.totalRows = 0;
      this.listcancelunicomInventoryReportData = [];
      this.searchFlag = false;
      this.FCClientProductID='';
      this.FCProductID='';
      this.FCRackID='';
      this.matchedinventorydropdown='';
      this.listreportfcinventorydata=[];
      this.listreportfcinventorydataCsv=[];
      this.labeltypeErr='';
      this.totalRowsFC=0;
      // if (this.user_type == 'warehouse_user')
      //   this.client = '';
      // else if (this.user_type == 'client_user')
      //   this.warehouse = '';
      // else {
      //   this.client = '';
      //   this.warehouse = '';
      // }
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/reports/unicominventorycomparisonreport/unicominventorycomparisonreport.component.js